export default __webpack_public_path__ + "assets/apple-touch-icon-76x76-8ededda.png";